import Component from '@glimmer/component';
import WrDetails from 'ember-wiser/components/details';
import WrForm from 'ember-wiser/components/form';
import FileAttachementRow from 'parog-web/components/dialysis/edition-form/file-attachement-row';
import type HemodialysisMeasuredJournalEvent from 'parog-web/models/hemodialysis-measured-journal-event';
import type TypedEmberChangeset from 'parog-web/utils/typed-ember-changeset';

interface Signature {
  Args: {
    measurement: TypedEmberChangeset<HemodialysisMeasuredJournalEvent>;
    onSubmit: () => Promise<void>;
  };
}

export default class HemodialysisSessionEditionFormEndSessionEditionFormComponent extends Component<Signature> {
  get changesetErrors() {
    const occurredAtTimeError = this.args.measurement.errors.find(
      e => e.key === 'occurredAtTime'
    );
    return occurredAtTimeError?.validation as string;
  }

  <template>
    <WrDetails @summary='Mesure 1' class='mt-2'>

      <WrForm @data={{@measurement}} @onSubmit={{@onSubmit}} as |form|>
        <form.InputRow
          @name='occurredAtTime'
          @label='Heure *'
          type='time'
          class={{if this.changesetErrors 'text-red border-b-red'}}
        >
          <div
            class='text-red pt-2 leading-[1.094rem] sm:pt-0'
            aria-label='occurredAtTimeError'
          >{{this.changesetErrors}}</div>
        </form.InputRow>

        <form.InputRow
          @label='Poids de sortie'
          @name='endOutputWeight'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 80'
        >kg</form.InputRow>

        <form.InputRow
          @label='Pression artérielle systolique'
          @name='endArterialSystolicPressure'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 120'
        >mmHg</form.InputRow>

        <form.InputRow
          @label='Pression artérielle diastolique'
          @name='endArterialDiastolicPressure'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 75'
        >mmHg</form.InputRow>

        <form.InputRow
          @label='Fréquence cardiaque'
          @name='endHeartRate'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 70'
        >mmHg</form.InputRow>

        <form.InputRow
          @label='Temps de compression des points veineux'
          @name='endVenousCompressionTime'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 5'
        >min</form.InputRow>

        <form.InputRow
          @label='Temps de compression des points artériels'
          @name='endArterialCompressionTime'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 10'
        >min</form.InputRow>

        <FileAttachementRow
          @form={{form}}
          @title='Prendre une photo de la machine'
        />

        <form.TextareaRow
          @label='Commentaires patient'
          @name='comments'
          class='mt-2 sm:mt-0'
          placeholder='Laisser un commentaire…'
        >
          &nbsp;
        </form.TextareaRow>

        {{! Hack: add a hidden native submit button so that
          pressing "Enter" triggers a proper HTML form submission. }}
        <button type='submit' class='hidden'></button>

      </WrForm>

    </WrDetails>
  </template>
}
